export default __webpack_public_path__ + "static/media/calendar-icon1.800de40d.svg";